var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_138_135391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75741 3.16717H2.58123C2.94119 4.4916 4.30665 5.27346 5.63108 4.91349C6.48171 4.6823 7.14621 4.0178 7.37741 3.16717H15.4226C15.7908 3.16717 16.0892 2.86873 16.0892 2.50058C16.0892 2.13243 15.7908 1.83399 15.4226 1.83399H7.37741C7.01744 0.509526 5.65199 -0.272333 4.32755 0.087631C3.47692 0.318827 2.81242 0.983323 2.58123 1.83396H0.75741C0.389259 1.83396 0.0908203 2.1324 0.0908203 2.50055C0.0908203 2.8687 0.389259 3.16717 0.75741 3.16717Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4226 7.33374H13.5988C13.2395 6.0095 11.8748 5.2272 10.5506 5.58642C9.69927 5.81736 9.03421 6.48239 8.80326 7.33374H0.75741C0.389259 7.33374 0.0908203 7.63218 0.0908203 8.00033C0.0908203 8.36848 0.389259 8.66692 0.75741 8.66692H8.80326C9.16251 9.99117 10.5272 10.7735 11.8515 10.4142C12.7028 10.1833 13.3678 9.51828 13.5988 8.66692H15.4226C15.7908 8.66692 16.0892 8.36848 16.0892 8.00033C16.0892 7.63218 15.7908 7.33374 15.4226 7.33374Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4226 12.8329H7.37741C7.01744 11.5085 5.65199 10.7266 4.32755 11.0866C3.47692 11.3178 2.81242 11.9823 2.58123 12.8329H0.75741C0.389259 12.8329 0.0908203 13.1313 0.0908203 13.4995C0.0908203 13.8676 0.389259 14.1661 0.75741 14.1661H2.58123C2.94119 15.4905 4.30665 16.2724 5.63108 15.9124C6.48171 15.6812 7.14621 15.0167 7.37741 14.1661H15.4226C15.7908 14.1661 16.0892 13.8676 16.0892 13.4995C16.0892 13.1313 15.7908 12.8329 15.4226 12.8329Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_135391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0898438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.f6323c4bc423e1cee3d935e7be84f2e5.svg";
export { ForwardRef as ReactComponent };